import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { chrysalisConfig } from '../../../chrysalis-config';



export class SidebarItemComponent {
  arrows = false;
   isCollapse: boolean;
   menuItem: any;
   toggleCollapse = new EventEmitter<any>();
  constructor(private chryConfig: chrysalisConfig, private Store: Store<any>) { }

  onToggleSub(event) {
    if (this.sidebarCollapse()) {
      this.Store.dispatch({ type: this.chryConfig.NORMAL });
      this.toggleCollapse.emit(false);
    }
  }

  private sidebarCollapse() {
    return window.innerWidth <= this.chryConfig.layoutSize.widthCollapseSidebar;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sidebarItem',
  template: "\n    <li chSlideToggle><a *ngIf=\"menuItem.children\" class=\"ch-sidebar-list-link ch-sidebar-parent\" (click)=\"onToggleSub($event)\" routerLinkActive=\"active\"><i class=\"{{menuItem.icon}} sid-parent-i\"></i> <span class=\"sid-parent-span\">{{menuItem.title}}</span> <b class=\"fa fa-angle-down sid-parent-b\"></b> </a><a *ngIf=\"!menuItem.children\" class=\"ch-sidebar-list-link\" [routerLink]=\"menuItem.route\" routerLinkActive=\"active\"><i class=\"{{menuItem.icon}}\"></i> <span>{{menuItem.title}}</span></a><ul *ngIf=\"menuItem.children\" class=\"sidebar-childlist\"><sidebarItem [menuItem]=\"subItem\" *ngFor=\"let subItem of menuItem.children\"></sidebarItem></ul></li>\n  ",
  styles: ["\n    .active{font-weight:600;color:#00abff!important}.active:hover{color:#00abff!important}\n  "]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: chrysalisConfig, },
{type: Store, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'isCollapse': [{ type: Input },],
'menuItem': [{ type: Input },],
'toggleCollapse': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
